import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'
import { TabListItem } from '@/ui/molecules/tabs/styled'

export const TopCarsBannerTabList = styled.ul(
  ({ theme }) => `
  border-bottom: .1rem solid ${theme.colors.grey.light4};
  display: flex;
  list-style-type: none;
  width: 100%;
  overflow-x: scroll;

  ${MEDIA_QUERIES(theme).medium}{
    padding-inline: ${theme.spacing.defaultSmall};
  }
`
)

export const TopCarsBannerTabListItem = styled(TabListItem)(
  ({ theme }) => `
  padding-inline: 0;
  padding-bottom: ${theme.spacing.defaultSmall};
  justify-content: unset;
  font-size: ${theme.typography.body.large.fontSize};
  margin-inline: ${theme.spacing.default};
  border-bottom: 0.3rem solid transparent;
  color: ${theme.colors.grey.primary};
  font-weight: ${theme.fontWeight.semiBold} !important;

  &[aria-current='page'] {
    border-bottom: 0.3rem solid ${theme.colors.purple.primary};
  }
  
  &:hover {
    border-bottom-width: 0.3rem;
  }

  &:focus {
    border-radius: unset;
    box-shadow: unset;
    outline: unset;
  } 

  ${MEDIA_QUERIES(theme).small}{
    min-width: 12rem;
  }

  ${MEDIA_QUERIES(theme).medium}{
    padding-bottom: ${theme.spacing.default};
    font-size: 2.8rem;
  }
  `
)
